import * as React from "react";
import classNames from "classnames";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import {
    ToggleWorkflowMultiSelectMode,
} from "source/app/services/Workflows/WorkflowSelection";

export function SelectNodes({
    compact = false,
    isMultiSelectMode,
}: {
    compact?: boolean;
    isMultiSelectMode: boolean;
}) {
    const containerStyleClass = StyleClass(
        `selectMultipleWorkflowNodesOptionContainer`,
        {
            alignItems: "center",
            color: "#acacac",
            display: "inline-flex",
            fontSize: "11px",
            fontWeight: "normal",
            whiteSpace: "nowrap",
        }
    );

    const activeStyleClass = StyleClass(`workflowMultiSelectActive`, {
        background: "rgba(90, 180, 210, 0.12)",
        borderRadius: "4px",
        color: "#8fe8ff",
        fontWeight: "bold",
        padding: "1px 4px",
        textShadow: "0 0 8px rgba(120, 220, 255, 0.85)",
    });

    return (
        <span data-is-selecting={isMultiSelectMode}>
            <IconWithText
                iconSuffix={EGlyphicon.list}
                whenClicked={async () => {
                    ToggleWorkflowMultiSelectMode();
                }}
                displayAsBlock={false}
                withClass={classNames(containerStyleClass, {
                    [activeStyleClass]: isMultiSelectMode,
                })}
            >
                {compact ? undefined : "Select multiple"}
            </IconWithText>
        </span>
    );
}
